module.exports = __webpack_public_path__ + "static/media/24.0795440a.jpg";